import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form, Button, Col, Row, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import { GrLanguage } from "react-icons/gr";
import Badge from "react-bootstrap/Badge";
import {
  changeSelectedTemplate,
  getTemplates,
  showLoader,
  changeTemplateFlow,
  clearQRTemplateStore,
  activateOrDeactivateTemplate,
  getCategories,
  createCategory,
  updateCategory,
  moveTemplate,
} from "../../redux/actions/templateActions";
import {
  QR_TEMPLATE_CREATE,
  QR_TEMPLATE_LIST,
} from "../../utils/permissionList";
import CreateTemplateModal from "../../components/modals/CreateTemplateModal";
import TemplateMenu from "../../components/action-menus/TemplateMenu";
import ViewTemplateModal from "../../components/modals/ViewTemplateModal";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import { ShowForPermission } from "../../components/ShowForPermission";
import {
  SOMETHING_WENT_WRONG,
  UNAUTHORIZED_ACTION,
} from "../../utils/errorMessages";
import { getLanguages } from "../../redux/actions/languageActions";
import { receiveMarketData } from "../../redux/actions/profileActions";
import SaveTemplateModal from "../../components/modals/SaveTemplateModal";
import { MdKeyboardArrowLeft } from "react-icons/md";
import CreateCategoryModal from "../../components/modals/CreateCategoryModal";
import CategoryMenu from "../../components/action-menus/CategoryMenu";
import MoveTemplateModal from "../../components/modals/MoveTemplateModal";
// import { useHistory } from "react-router-dom";


const CustomTemplates = ({
  templates = [],
  selectTemplate,
  userGroups,
  isLoading,
  getTemplateList,
  changeTemplateFlow,
  getLanguageList,
  activateOrDeactivateTemplate,
  isSuperAdmin,
  marketOptions = [],
  clearStore,
  receiveMarketData,
  getCategories,
  categories = [],
  createCategory,
  updateCategory,
  moveTemplate, // added action
}) => {
  const [showCreateTemplateModal, setShowCreateTemplateModal] = useState(false);
  const [selectedMarket, setSelectedMarket] = useState("kenya");
  const [template, setTemplate] = useState(false);
  const [isEditFlow, setIsEditFlow] = useState(false);
  const [showViewTemplateModal, setShowViewTemplateModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showSaveTemplateModal, setShowSaveTemplateModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  // const [categoryTemplates, setCategoryTemplates] = useState([]);
  const [showCreateCategoryModal, setShowCreateCategoryModal] = useState(false);
  const [categoryToEdit, setCategoryToEdit] = useState(null);
  const [isEditingCategory, setIsEditingCategory] = useState(false);
  const [categoryAction, setCategoryAction] = useState(null);
  const [showCategoryConfirmation, setShowCategoryConfirmation] = useState(false);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [templateToMove, setTemplateToMove] = useState(null);
  const [selectedArchiveCategory, setSelectedArchiveCategory] = useState(false);
  // const history = useHistory();

  const toggleTemplateActivityModal = (template) => {
    setTemplate(template);
    setShowConfirmation(true);
  };

  const toggleViewTemplateModal = (template) => {
    setTemplate(template);
    toggleShowViewTemplateModal();
  };
  const toggleEditTemplateModal = (template) => {
    changeTemplateFlow("EDIT");
    selectTemplate(template);
    setTemplate(template);
    setIsEditFlow(true);
    toggleShow();
  };

  useEffect(async () => {
    
    marketOptions.length > 0 && !marketOptions.find(m => m.value === selectedMarket) && setSelectedMarket(marketOptions[0].value);

    isLoading(true);
    getLanguageList({ isDropdown: true, isActiveOnly: true });
    await getTemplateList(selectedMarket)
      .then((result) => {
        // isLoading(false);
      })
      .catch((e) => {
        if (e.response.status && e.response.status === 403) {
          toast.error(UNAUTHORIZED_ACTION);
        } else if (e.response.data.Description) {
          toast.error(e.response.data.Description);
        } else {
          toast.error(SOMETHING_WENT_WRONG);
        }
      });
      await getCategories(selectedMarket, null, false, false);
      isLoading(false);
  }, [selectedMarket, getTemplateList, isLoading, changeTemplateFlow, getCategories]);

  useEffect(() => {
    receiveMarketData();
  }, []);
  
  // useEffect(() => {
  //   setCategoryTemplates(templates.filter(t => t.templateName.includes("Test")));
  // }, [selectedCategory]);

  // clear the store on unmount 
  useEffect(() => () => clearStore(), [clearStore]);

  const handleCreateTemplate = () => {
    changeTemplateFlow("CREATE");
    setIsEditFlow(false);
    toggleShow();
  };

  const toggleShow = () => setShowCreateTemplateModal((p) => !p);
  const toggleShowViewTemplateModal = () => setShowViewTemplateModal((p) => !p);
  const toggleShowSaveTemplateModal = () => setShowSaveTemplateModal((p) => !p);
  const toggleCreateCategoryModal = () => setShowCreateCategoryModal((p) => !p);
  const toggleMoveModal = () => setShowMoveModal((p) => !p);

  const openCreateCategory = () => {
    setCategoryToEdit(null);
    setIsEditingCategory(false);
    toggleCreateCategoryModal();
  };

  const openEditCategory = (category) => {
    setCategoryToEdit(category);
    setIsEditingCategory(true);
    toggleCreateCategoryModal();
  };

  const openMoveModal = (template) => {
    setTemplateToMove(template);
    setShowMoveModal(true);
  };

  const toggleCategoryConfirmation = (category) => {
    setCategoryAction(category);
    setShowCategoryConfirmation(true);
  };

  const handleSaveCategory = async (payload) => {
    isLoading(true);
    try {
      if (isEditingCategory) {
        await updateCategory(payload);
        toast.success("Category updated");
      } else {
        await createCategory(payload);
        toast.success("Category created");
      }
      // refresh categories for current market
      getCategories(selectedMarket, null, false, false);
      toggleCreateCategoryModal();
    } catch (e) {
      if (e?.response?.data?.Description) {
        toast.error(e.response.data.Description);
      } else {
        toast.error(SOMETHING_WENT_WRONG);
      }
    } finally {
      isLoading(false);
    }
  };

  const handleCategoryActivationAndDeactivation = async () => {
    if (!categoryAction) return;
    isLoading(true);
    try {
      // reuse updateCategory to toggle isActive
      await updateCategory({
        id: categoryAction.id,
        name: categoryAction.name,
        market: categoryAction.market,
        isActive: !categoryAction.isActive,
      });
      toast.success(`Category ${categoryAction.isActive ? "Archived" : "Activated"}`);
      // refresh categories
      await getCategories(selectedMarket, null, false, false);
      await getTemplateList(selectedMarket);
    } catch (e) {
      if (e?.response?.data?.Description) {
        toast.error(e.response.data.Description);
      } else {
        toast.error(SOMETHING_WENT_WRONG);
      }
    } finally {
      isLoading(false);
      setShowCategoryConfirmation(false);
      setCategoryAction(null);
    }
  };

  const handleTemplateActivationAndDeactivation = async () => {
    const data = { templateId: template.id, isActivated: template.isActive };
    isLoading(true);
    activateOrDeactivateTemplate(data)
      .then(async (result) => {
        await getTemplateList(selectedMarket)
          .then((result) => {
            toast.success(
              `Template ${template.isActive ? "Archived" : "Activated"}`
            );
            isLoading(false);
          })
          .catch((err) => {
            toast.error("Something went wrong");
            isLoading(false);
          });
      })
      .catch((e) => {
        if (e.response.status && e.response.status === 403) {
          toast.error(UNAUTHORIZED_ACTION);
        } else if (e.response.data.Description) {
          toast.error(e.response.data.Description);
        } else {
          toast.error(SOMETHING_WENT_WRONG);
        }
        isLoading(false);
      });
  };

  const handleMoveConfirm = async (payload) => {
    // payload: { id, templateCategoryId }
    isLoading(true);
    try {
      await moveTemplate(payload);
      toast.success("Template moved");
      // refresh templates and categories
      await getTemplateList(selectedMarket);
      await getCategories(selectedMarket, null, false, false);
      setShowMoveModal(false);
    } catch (e) {
      if (e?.response?.data?.Description) {
        toast.error(e.response.data.Description);
      } else {
        toast.error(SOMETHING_WENT_WRONG);
      }
    } finally {
      isLoading(false);
    }
  };

  const renderArchiveFolder = () => {
    return (
      <Col lg={3} md={6} sm={6}>
        <Card
          id="archive-folder"
          onClick={() => setSelectedArchiveCategory(true)}
          style={{
            minHeight: 295,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            cursor: "pointer",
            backgroundColor: "#f1f3f5",
          }}
        >
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
              padding: 8,
              boxSizing: "border-box",
            }}
            aria-live="polite"
          >
            <h1
              style={{
                margin: 0,
                fontSize: "1.25rem",
                fontWeight: 700,
                color: "#495057", // neutral strong color
                textAlign: "center",
              }}
            >
              Archived Templates
            </h1>
          </div>
        </Card>
      </Col>
    );
  }

  // show archive folder only if there are archived categories or archived templates
  const hasArchived = (categories || []).some(c => c.isActive === false) || (templates || []).some(t => t.isActive === false);

  const renderCategories = categories.filter(c =>  c.isActive === !selectedArchiveCategory).map((category) => {

    const templatesImages = templates.filter(t => (t.templateCategoryId === category.id) && (!selectedArchiveCategory ? t.isActive === true : true)).map(t => t.pngTemplatePath);
   
    return (
      <Col lg={3} md={6} sm={6} key={category.id}>
        <Card
          id={category.id + "-" + category.name}
          onClick={() => setSelectedCategory(category)}
        >
          <div className={category.isActive ? "temp-card-dropdown d-flex justify-content-end" : "temp-card-dropdown align-items-center d-flex justify-content-between" }>
             {!category.isActive && <Badge bg="dark" text="light">
                  Archived
              </Badge>}
            <div onClick={(e) => e.stopPropagation()}>
              <CategoryMenu
                category={category}
                editCategory={openEditCategory}
                toggleCategoryActivity={toggleCategoryConfirmation}
                userIsSuperAdmin={isSuperAdmin}
              />
            </div>
          </div>
              <div className="wrap-img" style={{ backgroundColor: "#FFF" }}>
                <Row className="mx-0">
                    {templatesImages.slice(0, 6).map((Icon, index) => (
                      <Col
                        key={index}
                        xs={4} 
                        className="d-flex justify-content-center p-2"
                      >
                        <Card
                          className="d-flex justify-content-center align-items-center shadow-sm mb-0"
                        >
                          <Card.Body className="d-flex justify-content-center align-items-center">
                            <img
                              src={Icon}
                              alt={`Icon ${index + 1}`}
                              width={50}
                              height={50}
                              style={{ objectFit: "contain" }}
                            />
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                    {templatesImages.length === 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: 140,
                          width: "100%",
                          // backgroundColor: "#fff3cd", // soft warning background
                          color: "#856404", // darker warning text
                          borderRadius: 6,
                          marginTop: 8,
                          marginBottom: 8,
                          fontWeight: 600,
                        }}
                        aria-live="polite"
                      >
                        No templates in this category
                      </div>
                    )}
                  </Row>
              </div>
              <Card.Body className="d-flex justify-content-between" style={{ padding: "22px" }}>
                <Card.Text id={category.id + "-" + category.name + "-name"}>
                  {category.name}
                </Card.Text>
              </Card.Body>
        </Card>
      </Col>
    );
  });

  const isTemplateDisplay = (template) => {
    if(selectedCategory === null && !selectedArchiveCategory) {
      return (template.templateCategoryId === null || template.templateCategoryId === "") && template.isActive === true;
    } else if(selectedCategory === null && selectedArchiveCategory) {
      return template.isActive === false && (template.templateCategoryId === null || template.templateCategoryId === "" || categories.find(c => c.id === template.templateCategoryId)?.isActive === true);
    } else if(selectedCategory !== null && !selectedArchiveCategory) {
      return (template.templateCategoryId === selectedCategory.id) && template.isActive;
    } else if (selectedCategory !== null && selectedArchiveCategory) {
      return (template.templateCategoryId === selectedCategory.id);
    }
    return false;
  }

  const renderTemplates = templates.filter(t => isTemplateDisplay(t)).map((template) => {

    return (
      <Col lg={3} md={6} sm={6} key={template.id}>
        <Card id={template.id + "-" + template.language}>
          <div className="temp-card-dropdown d-flex justify-content-end">
            {template.isActive ? (
              <div onClick={(e) => e.stopPropagation()}>
                <TemplateMenu
                  template={template}
                  toggleTemplateActivity={toggleTemplateActivityModal}
                  viewTemplate={toggleViewTemplateModal}
                  editTemplate={toggleEditTemplateModal}
                  openMoveModal={openMoveModal}
                  templateIsActive={template?.isActive}
                  templateIsGeneral={template?.market.includes("general")}
                  userIsSuperAdmin={isSuperAdmin}
                />
              </div>
            ) : (
              <div className="d-flex w-100 align-items-center justify-content-between">
                <Badge bg="dark" text="light">
                  Archived
                </Badge>
                <div onClick={(e) => e.stopPropagation()}>
                  <TemplateMenu
                    template={template}
                    toggleTemplateActivity={toggleTemplateActivityModal}
                    viewTemplate={toggleViewTemplateModal}
                    editTemplate={toggleEditTemplateModal}
                    openMoveModal={openMoveModal}
                    templateIsActive={template?.isActive}
                    templateIsGeneral={template?.market.includes("general")}
                    userIsSuperAdmin={isSuperAdmin}
                  />
                </div>
              </div>
            )}
          </div>
          {template.isActive ? (
            <div>
              <div className="wrap-img">
                <Card.Img
                  variant="top"
                  src={template.pngTemplatePath}
                  alt={template.templateName}
                />
              </div>
              <Card.Body className="d-flex justify-content-between">
                <Card.Text id={template.id + "-" + template.language + "-name"}>
                  {template.templateName}
                </Card.Text>

                {template.isDefault ? (
                  <Button
                    data-testid="cancelButton"
                    variant="primary"
                    className="btn-cancel"
                    id={
                      "btn-" + template.id + "-" + template.language + "-lang"
                    }
                  >
                    <span>Default</span>
                  </Button>
                ) : (
                  <Button
                    data-testid="cancelButton"
                    variant="primary"
                    className="btn-cancel"
                    id={
                      "btn-" + template.id + "-" + template.language + "-lang"
                    }
                  >
                    <GrLanguage className="lcon-lang" />
                    <span className="txt-lan">{template.language}</span>
                  </Button>
                )}
              </Card.Body>
            </div>
          ) : (
            <div className="deactivated">
              <div className="wrap-img">
                <Card.Img
                  variant="top"
                  src={template.pngTemplatePath}
                  alt={template.templateName}
                />
              </div>
              <Card.Body className="d-flex justify-content-between">
                <Card.Text id={template.id + "-" + template.language + "-name"}>
                  {template.templateName}
                </Card.Text>

                {template.isDefault ? (
                  <Button
                    data-testid="cancelButton"
                    variant="primary"
                    className="btn-cancel"
                    id={
                      "btn-" + template.id + "-" + template.language + "-lang"
                    }
                  >
                    <span>Default</span>
                  </Button>
                ) : (
                  <Button
                    data-testid="cancelButton"
                    variant="primary"
                    className="btn-cancel"
                    id={
                      "btn-" + template.id + "-" + template.language + "-lang"
                    }
                  >
                    <GrLanguage className="lcon-lang" />
                    <span className="txt-lan">{template.language}</span>
                  </Button>
                )}
              </Card.Body>
            </div>
          )}
        </Card>
      </Col>
    );
  });

  const toggleSetShowConfirmation = () => setShowConfirmation((p) => !p);
  const toggleSetShowCategoryConfirmation = () => setShowCategoryConfirmation((p) => !p);

  const backNavigation = () => {
    if(selectedCategory != null && selectedArchiveCategory) {
      setSelectedCategory(null);
    }
    else if(selectedCategory == null && selectedArchiveCategory) {
      setSelectedArchiveCategory(false);
    } else {
      setSelectedCategory(null);
      setSelectedArchiveCategory(false);
    }
  }

  return (
    <div className="page qr-genarate-page">
      <CreateCategoryModal
        show={showCreateCategoryModal}
        toggleShow={toggleCreateCategoryModal}
        onSave={handleSaveCategory}
        marketOptions={marketOptions}
        initialData={categoryToEdit ?? { market: selectedMarket }} // autofill market on create
        isEditing={isEditingCategory}
        isSuperAdmin={isSuperAdmin}
      />
      <ConfirmationModal
        show={showCategoryConfirmation}
        toggleShow={toggleSetShowCategoryConfirmation}
        confirm={handleCategoryActivationAndDeactivation}
        body={categoryAction ? `This will ${categoryAction.isActive ? "archive" : "activate"} the category "${categoryAction.name}".` : ""}
        title={`Are you sure you want to ${categoryAction?.isActive ? "Archive" : "Activate"} this category?`}
      />
      <ViewTemplateModal
        template={template}
        show={showViewTemplateModal}
        toggleShow={toggleShowViewTemplateModal}
      />
        <CreateTemplateModal
          show={showCreateTemplateModal}
          template={template}
          selectedMarket={selectedMarket}
          selectedCategory={selectedCategory} // pass parent selected category (may be null)
          toggleShow={toggleShow}
          isEditFlow={isEditFlow}
          openSaveModal={toggleShowSaveTemplateModal}
        />
      <ConfirmationModal
        show={showConfirmation}
        toggleShow={toggleSetShowConfirmation}
        confirm={handleTemplateActivationAndDeactivation}
        title={`Are you sure you want to ${
          template.isActive ? "Archive" : "Activate"
        } this template?`}
      />

      <SaveTemplateModal show={showSaveTemplateModal} toggleShow={toggleShowSaveTemplateModal} template={template} isEditFlow={isEditFlow} />

      <MoveTemplateModal
        show={showMoveModal}
        toggleShow={toggleMoveModal}
        template={templateToMove}
        categories={categories.filter(c => c.isActive)}
        onMove={handleMoveConfirm}
      />
  
      <div className="page-title-row d-flex justify-content-between">
        <div className="title">
            <div className="d-flex align-items-baseline">
              <h1 className="mb-0">Templates</h1>
              {selectedArchiveCategory && <h6 className="mb-0 ms-2 fw-normal text-muted">/ Archive</h6>}
              {selectedCategory != null && <h6 className="mb-0 ms-2 fw-normal text-muted">/ {selectedCategory.name}</h6>}
            </div>
          <div className="subtitle-1">
            Create and edit custom qr code templates
          </div>
          {(selectedCategory != null || selectedArchiveCategory) && <div className="frm-btn btn-section">
            <Button
              data-testid="backButton"
              variant="primary"
              className="btn-link back-btn"
              onClick={backNavigation}
              name="back"
            >
              <MdKeyboardArrowLeft />
                Back To {(selectedCategory != null && selectedArchiveCategory) ? "Archive" : "Templates"}
            </Button>
          </div>}
        </div>
        {/* <div className="filter-section"> */}
          <div className="filter-components">
            <Form className="form w-100">
              <div className="align-items-center d-flex">
                {selectedCategory === null && <div className="my-1 mx-2">
                  {isSuperAdmin ? (
                    <Form.Select
                      style={{ paddingRight: "36px" }}
                      id="marketSelect"
                      value={selectedMarket} 
                      onChange={(e) => setSelectedMarket(e.target.value)}
                    >
                      {marketOptions.map((market) => {
                        return (
                          <option key={market.value} value={market.value}>
                            {market.displayName}
                          </option>
                        );
                      })}
                      <option value="general">General</option>
                    </Form.Select>
                  ) : (
                    <Form.Select
                      style={{ paddingRight: "36px" }}
                      id="marketSelect"
                      value={selectedMarket} 
                      onChange={(e) => setSelectedMarket(e.target.value)}
                    >
                      {marketOptions
                        ? marketOptions.length > 0 &&
                          marketOptions
                            .filter((x) => userGroups && userGroups.includes(x.userGroup))
                            .map((y) => {
                              return (
                                <option value={y.value}>{y.displayName}</option>
                              );
                            })
                        : null}
                    </Form.Select>
                  )}
                </div>}
                <div className="btn-csv">
                  {selectedCategory === null && <Button variant="secondary" className="me-2" onClick={openCreateCategory}>
                    Create Category
                  </Button>}
                  <ShowForPermission permissions={[QR_TEMPLATE_CREATE]}>
                    <Button
                      variant="primary"
                      id="createTemplate"
                      onClick={handleCreateTemplate}
                    >
                      <span className="mx-2">Create Template</span>
                    </Button>
                  </ShowForPermission>
                </div>
              </div>
            </Form>
          </div>
        {/* </div> */}
      </div>

      <div className="card-set-qr">
        <ShowForPermission permissions={[QR_TEMPLATE_LIST]} showBanner>
          <Row>
            {selectedCategory === null && renderCategories} 
            {renderTemplates} 
            {hasArchived && !selectedArchiveCategory && selectedCategory === null && renderArchiveFolder()} 
          </Row>
        </ShowForPermission>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    templates: state.templates.list,
    userGroups: state.profile?.groups,
    isSuperAdmin: state.permission.isSuperAdmin,
    marketOptions: state.profile.markets,
    categories: state.templates.categories,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTemplateList: (market) => dispatch(getTemplates(market)),
  selectTemplate: (data) => dispatch(changeSelectedTemplate(data)),
  isLoading: (flag) => dispatch(showLoader(flag)),
  changeTemplateFlow: (flag) => dispatch(changeTemplateFlow(flag)),
  activateOrDeactivateTemplate: (data) =>
    dispatch(activateOrDeactivateTemplate(data)),
  getLanguageList: (filters) => dispatch(getLanguages(filters)),
  clearStore: () => dispatch(clearQRTemplateStore()),
  receiveMarketData: () => dispatch(receiveMarketData()),
  getCategories: (market, name, isArchive, isActive) => dispatch(getCategories(market, name, isArchive, isActive)),
  createCategory: (payload) => dispatch(createCategory(payload)),
  updateCategory: (payload) => dispatch(updateCategory(payload)),
  moveTemplate: (payload) => dispatch(moveTemplate(payload)), // new action
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomTemplates);
